// extracted by mini-css-extract-plugin
export default {"search":"UnassignedPanelData_search__gFQW2","spinnerContainer":"UnassignedPanelData_spinnerContainer__gcy2i"};